import type { ReactNode } from 'react'
import { FileQuestion } from 'lucide-react'
import { EmptyState } from '@shared/design-system/ui'
import { useMemberBrandQuery } from '../api/member-access.queries'

export function MemberAreaGate({
  producerId,
  children,
}: {
  producerId: string
  children: ReactNode
}) {
  const brand = useMemberBrandQuery(producerId)
  if (brand.isPending) return null
  if (brand.isError || brand.data?.enabled !== true) {
    return (
      <EmptyState
        data-testid="member-area-unavailable"
        icon={<FileQuestion />}
        title="Página indisponível"
        description="Esta página não está disponível."
      />
    )
  }
  return children
}
